import script from "./WorkerSetupInstructions.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkerSetupInstructions.vue?vue&type=script&setup=true&lang=js"

import "./WorkerSetupInstructions.vue?vue&type=style&index=0&id=a554c5f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a554c5f0"]])

export default __exports__